module.exports = __webpack_public_path__ + "static/media/thomas indoor soccer center.900fabf7.jpeg";